<template>
  <div>
    <Header></Header>
    <div class="row">
      <div class="col-md-12 email-wrapper">
        <iframe :src="iframeSrc" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Header from './header'
import { mapGetters } from "vuex";
const qs = require('qs')
export default {
  data() {
    return {
      iframeSrc: "",
      action: this.$route.query.action,
      emailAddress: this.$route.query.emailAddress,
      subject: this.$route.query.subject,
      message: this.$route.query.message,
      attachments: this.$route.query.attachments,
    };
  },
  components: {
    Header
  },
  computed: {
    ...mapGetters(["token"])
  },
  methods: {
    getEmailSettingF() {
      console.log("this.token");
      console.log(this.token);
      this.$store
        .dispatch("getEmailSetting")
        .then(resolve => {
          console.log("--getEmailSetting then");

          if (resolve.result) {
            console.log("email 1111");
            console.log(resolve);
            if (Object.keys(resolve.email_setting).length > 0) {
              console.log("email 222");
              if(this.emailAddress){
                console.log("email 33333");
                // QS de tek attachment gelince array yerine string geliyor
                if (this.attachments && Array.isArray(this.attachments)) {
                  console.log("email 4444");
                  this.attachments = [this.attachments]
                }
                let data = {
                  action: this.action,
                  token:this.token,
                  emailAddress: this.emailAddress,
                  subject: this.subject,
                  message: this.message,
                  attachments: this.attachments
                }
                console.log("*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/");
                console.log(data);
                console.log("girildi");
                var requestParameters = qs.stringify(data)
                var emailUrl = '/mail-client/rclogin.php'
                var redirectUrl = `${emailUrl}?${requestParameters}`
                this.iframeSrc = redirectUrl;
                
              }else {
                console.log("email 5555");
                console.log(this.token);
                this.iframeSrc = `/mail-client/rclogin.php?action=login&token=${this.token}`;
                console.log(this.iframeSrc);
              }

            } else {
              console.log("email 6666");
              this.$router.push("/settings?tab=email_settings");
            }
          } 
          else {
            console.log("email 77777");
            this.$router.push("/settings?tab=email_settings");
          }
        })
        .catch(e => {
          console.log(e);
          console.log("hata");
        });
    }
  },
  created() {
    this.getEmailSettingF();
  }
};
</script>
<style scoped>
.email-wrapper iframe {
  width: 100%;
  height: calc(100vh - 50px);
}
</style>
